import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import IconToolTip from '../../../../common/IconToolTip';
import { defaultGroupChatImage } from '../../ChatController';
import { validateStringValue } from '../../../../utils/common';
import { SkeltonCardTwo } from '../../../../common/SkeltonCardTwo';

function GroupDetailsInfo({ isEditEnable, editGroupDeatilsForm, onFormInputChange, setEditGroupDeatilsForm, groupDetailsInfo }) {
    const { isUpdateConversationLoading } = useSelector((state) => state.loading);
    const [uploadedImage, setUploadedImage] = useState('');
    const { openedConversationId } = useSelector((state) => state.conversations);
    const chatDetails = useSelector((state) => state.chat.chatDetails);
    const groupDetails = chatDetails[openedConversationId];


    useEffect(() => {
        setUploadedImage('');
    }, [openedConversationId]);


    const onFileUpload = (event) => {
        let uploadedImage = event.target.files[0];
        let image = '';
        if (uploadedImage) image = URL.createObjectURL(uploadedImage);
        setUploadedImage(image);
        setEditGroupDeatilsForm((prevState) => {
            return { ...prevState, conversationImage: uploadedImage };
        });
    };

    const getConversationImage = () => {
        let image = defaultGroupChatImage;
        if (uploadedImage) image = uploadedImage;
        else if (editGroupDeatilsForm?.preImage) image = editGroupDeatilsForm?.preImage;
        return image;
    };

    const getNameElement = () => {
        if (isEditEnable) {
            return (
                <input
                    placeholder='Chat Name'
                    name='name'
                    className='text-font15 text-scogo15 font-medium w-full px-3 py-2 rounded-md border border-scogoddd focus:border-scogoprimary focus:ring-1 focus:ring-scogoprimary transition-all outline-none'
                    value={editGroupDeatilsForm?.name}
                    onChange={onFormInputChange}
                />
            );
        }
        return (
            <h2 className='text-font16 text-scogo15 font-semibold break-all w-full'>
                {validateStringValue(groupDetails.title)}
            </h2>
        );
    };

    const getDescriptionElement = () => {
        if (isEditEnable) {
            return (
                <textarea
                    placeholder='Chat Description'
                    name='desc'
                    className='text-font13 font-normal text-scogogray w-full px-3 py-2 rounded-md border border-scogoddd focus:border-scogoprimary focus:ring-1 focus:ring-scogoprimary transition-all outline-none min-h-[80px] resize-none'
                    value={editGroupDeatilsForm?.desc}
                    onChange={onFormInputChange}
                />
            );
        }
        return (
            <p className='text-font13 font-normal text-scogogray w-full break-all leading-relaxed'>
                {validateStringValue(groupDetails?.description)}
            </p>
        );
    };

    const uploadIcon = () => {
        return (
            <div className='absolute top-4 right-4 z-10'>
                <IconToolTip title='Upload Image'>
                    <div className='relative bg-white p-2 rounded-full shadow-md hover:bg-gray-50 transition-all'>
                        <input
                            accept='image/png, image/gif, image/jpeg'
                            type='file'
                            className='absolute cursor-pointer opacity-0 z-5 h-full w-full'
                            onChange={onFileUpload}
                            value=''
                        />
                        <span className='text-scogoprimary material-icons text-font20'>photo_camera</span>
                    </div>
                </IconToolTip>
            </div>
        );
    };

    if (isUpdateConversationLoading) {
        return (
            <div className='px-4'>
                <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} size={30} />
            </div>
        );
    }

    return (
        <div className='bg-white rounded-lg overflow-hidden shadow-sm'>
            <div className='relative'>
                {isEditEnable && uploadIcon()}
                <div className='w-full max-h-96 overflow-hidden bg-gray-100'>
                    <img
                        src={getConversationImage()}
                        className='w-full h-48 object-fill transition-all duration-300 hover:scale-105'
                        alt={groupDetails?.title || 'Group Image'}
                    />
                </div>
            </div>
            <div className='px-6 py-5 space-y-4'>
                <div>{getNameElement()}</div>
                <div className='pt-1'>{getDescriptionElement()}</div>
                {!isEditEnable && groupDetails?.createdAt && (
                    <div className='flex items-center pt-2'>
                        <span className='material-icons text-scogogray text-font16 mr-2'>calendar_today</span>
                        <span className='text-font12 text-scogogray'>
                            Created on {new Date(groupDetails.createdAt).toLocaleDateString()}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default GroupDetailsInfo;
